module.exports = __webpack_public_path__ + "img/loading-icon.8dd2c7be.gif";